import React from "react";
import PropTypes from "prop-types";
import "../css/DoctorProfileCard.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
const DoctorProfileCard = ({
  avatar,
  name,

  speciality,
  rating,
  reviews,
  active,
  onStatusToggle,
  onDelete,
  doctor,
}) => {
  const navigate = useNavigate();

  const onViewProfile = () => {
    navigate("/doctor_profile", { state: { doctor } }); // ✅ passing doctor data via route state
  };

  return (
    <motion.div
      className="doctor-card"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      whileHover={{ scale: 1.03, boxShadow: "0 12px 20px rgba(0,0,0,0.4)" }}
      transition={{ duration: 0.1, ease: "easeOut" }}
    >
      <div className={`status-text ${active ? "active" : "inactive"}`}>
        {active ? "Active" : "Inactive"}
      </div>

      <div className="card-body">
        <motion.img
          src={avatar}
          alt={name}
          className="doc-avatar"
          whileHover={{ scale: 1.1 }}
          transition={{ type: "spring", stiffness: 300 }}
        />

        <div className="doc-info">
          <h3 className="doc-name">{name}</h3>
          <p className="doc-speciality">
            {speciality
              .split(",") // split multiple specialties
              .map((s) =>
                s
                  .trim()
                  .replace(/_/g, " ") // replace underscores
                  .split(" ") // split words
                  .map(
                    (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
                  ) // capitalize each word
                  .join(" ")
              )
              .join(", ")}{" "}
            {/* join back with comma and space */}
          </p>

          <div className="doc-bottom-row">
            <div className="doc-rating">
              <span className="star">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={23.41}
                  height={23.41}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="#FFC107"
                    d="m12 17.275l-4.15 2.5q-.275.175-.575.15t-.525-.2t-.35-.437t-.05-.588l1.1-4.725L3.775 10.8q-.25-.225-.312-.513t.037-.562t.3-.45t.55-.225l4.85-.425l1.875-4.45q.125-.3.388-.45t.537-.15t.537.15t.388.45l1.875 4.45l4.85.425q.35.05.55.225t.3.45t.038.563t-.313.512l-3.675 3.175l1.1 4.725q.075.325-.05.588t-.35.437t-.525.2t-.575-.15z"
                  />
                </svg>
              </span>
              <span className="rating-value">{rating}</span>
              <span className="reviews">({reviews} reviews)</span>
            </div>

            <motion.div
              className="doc-delete"
              whileTap={{ scale: 0.9, rotate: -10 }}
              transition={{ type: "spring", stiffness: 300 }}
              onClick={onDelete}
              title="Delete"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zm2-4h2V8H9zm4 0h2V8h-2z"
                />
              </svg>
            </motion.div>
          </div>
        </div>
      </div>

      <motion.button
        className="view-profile-btn"
        onClick={onViewProfile}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <span className="profile-icon" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={18}
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
              <path d="M16 9a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-2 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0" />
              <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1M3 12c0 2.09.713 4.014 1.908 5.542A8.99 8.99 0 0 1 12.065 14a8.98 8.98 0 0 1 7.092 3.458A9 9 0 1 0 3 12m9 9a8.96 8.96 0 0 1-5.672-2.012A6.99 6.99 0 0 1 12.065 16a6.99 6.99 0 0 1 5.689 2.92A8.96 8.96 0 0 1 12 21" />
            </g>
          </svg>
        </span>
        <span className="view-profile-text">View Profile</span>
      </motion.button>
    </motion.div>
  );
};

DoctorProfileCard.propTypes = {
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  gstn: PropTypes.string.isRequired,
  speciality: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  reviews: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  doctor: PropTypes.object.isRequired,
};

DoctorProfileCard.defaultProps = {
  onDelete: () => {},
};

export default DoctorProfileCard;
